<template>
    <div class="land-arch">
        <div class="container">
            <div class="arch-pic arch-pic-mobile arch-pic-duman" v-if="projectNameG == 'duman' && isMobileChecker">
                <img :src="salesCard.arch_img" alt="" v-if="!isMobileChecker">
                <img :src="salesCard.arch_img_mobile" alt="" v-if="isMobileChecker" class="img-mobile" :class="{'filter-init' : salesCard.arch_section_title_mobile != null && salesCard.arch_section_title_mobile != ''}">
                <strong class="title-mobile" :class="{'duman' : projectNameG == 'duman', 'public-style' : projectNameG != 'duman'}" v-if="isMobileChecker && salesCard.arch_section_title_mobile != null && salesCard.arch_section_title_mobile != ''">{{ salesCard.arch_section_title_mobile }}</strong>
            </div>
            <div class="section-title">
                <h2>{{salesCard.arch_section_title}}</h2>
            </div>
            <div class="section-title-desc" v-if="salesCard.arch_section_title_desc != null && salesCard.arch_section_title_desc != ''">
                <p v-html="salesCard.arch_section_title_desc"></p>
            </div>
            <div class="arch-nav">
                <ul>
                    <li><a href="#" @click.prevent="activePins = 'fasad'" :class="{'active' : activePins == 'fasad'}">{{salesCard.arch_section_nav.fasad}}</a></li>
                    <li><a href="#" @click.prevent="activePins = 'materials'" :class="{'active' : activePins == 'materials'}">{{salesCard.arch_section_nav.materials}}</a></li>
                </ul>
            </div>
            <div class="arch-pic">
                <img :src="salesCard.arch_img" alt="" v-if="!isMobileChecker">
                <img :src="salesCard.arch_img_mobile" alt="" v-if="isMobileChecker" class="img-mobile" :class="{'filter-init' : salesCard.arch_section_title_mobile != null && salesCard.arch_section_title_mobile != ''}">
            </div>
            <div class="arch-info-pins">
                <div class="pins-items fasad-pins" v-if="activePins == 'fasad'">
                    <div class="pin" v-for="(item, index) in salesCard.arch_pins" :key="index">
                        <strong v-html="item.name"></strong>
                        <p v-html="item.desc"></p>
                    </div>
                </div>
                <div class="pins-items materials-pins" v-else>
                    <div class="pin" v-for="(item, index) in salesCard.arch_pins_materials" :key="index">
                        <strong v-html="item.name"></strong>
                        <p v-html="item.desc"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-arch',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                activePins: 'fasad',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-arch.scss';
    @import '@/styles/components/sales/respond/land-arch-respond.scss';
</style>